import React from "react";
import "../index.css";

const Header = () => {
    return (
       <header className="navbar">
          <h1>Flair <kbd className="kbd">Test</kbd></h1>
       </header>
    );
};


export default Header;